module.exports = __webpack_public_path__ + "media/images/logo-compleet-wit-ac2345d1e9e24114bb866c1c6b50eb5e.svg";